"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeUsers_en_us = void 0;
function backofficeUsers_en_us() {
    return {
        "backoffice.users.title": "Users",
        "backoffice.users.registeredat": "Registered at",
        "backoffice.users.subtitle": "Here you can invite users to be members of your company and projects.",
        "backoffice.users.edit.title": "Edit user",
        "backoffice.users.permissionstring": "Permissions",
        "backoffice.users.projects": "Projects",
        "backoffice.users.project": "Project",
        "backoffice.users.name": "Name",
        "backoffice.users.company": "Company",
        "backoffice.users.mail": "E-Mail",
        "backoffice.users.mailvalidated": "E-Mail verified",
        "backoffice.users.mailnotvalidated": "E-Mail not verified",
        "backoffice.users.me": "me",
        "backoffice.users.invite": "Invite",
        "backoffice.users.permissions.read": "Read",
        "backoffice.users.permissions.write": "Write",
        "backoffice.users.permissions.admin": "Administrator",
        "backoffice.users.permissionmanagement.deleteheader": "Revoke Permission",
        "backoffice.users.permissionmanagement.deletemessage": "Are you sure you would like to remove this users permission?",
        "backoffice.users.permissionmanagement.add": "Add new permission",
        "backoffice.users.management.title": "Co Workers",
        "backoffice.users.invitations.title": "Invitations",
        "backoffice.users.invitations.subtitle": "All the people invited in your company and projects",
        "backoffice.users.invitations.activeinvites": "Open invitations",
        "backoffice.users.invitations.inactiveinvites": "Accepted invitations",
        "backoffice.users.invitations.invitedate": "Invite Date",
        "backoffice.users.invitations.inviteremail": "Inviter Email",
        "backoffice.users.invitations.targetemail": "Target Email",
        "backoffice.users.invitations.company": "Company Permissions",
        "backoffice.users.invitations.permissions": "Project Permissions",
        "backoffice.users.invitations.project": "Project",
        "backoffice.users.invitations.companyinvitation": "Company only invitation. No project permissions.",
        "backoffice.users.invitations.noprojectpermission": "Viewing the project is not allowed.",
        "backoffice.users.invitations.buttons.delete": "Delete",
        "backoffice.users.invitations.buttons.resend": "Resend",
        "backoffice.users.invitations.empty.title": "No pending invitations",
        "backoffice.users.invitations.empty.message": "Over here you can see any pending invitations. Start inviting your team now.",
        "backoffice.users.invitations.invitemessage": "You have received an invitation from user ''${name}'' of the company ''${company}'' ${project}",
        "backoffice.users.invitations.fortheproject": " for the project ''",
        "backoffice.users.invitations.errors.sourceusernotfound": "Could not find inviting user!",
        "backoffice.users.invitations.errors.missingpermissions": "You can only invite other people to companies or projects in which you are an administrator.",
        "backoffice.users.editprofile.title": "Edit Profile",
        "backoffice.users.editprofile.confirmresendverifymailatsave.title": "E-Mail not verified",
        "backoffice.users.editprofile.confirmresendverifymailatsave.message": "The email address of this customer is not verified yet. Do you want to resend the verification mail?",
        "backoffice.users.editprofile.confirmresendverifymail.title": "Verfication email",
        "backoffice.users.editprofile.confirmresendverifymail.message": "Do you want to resend the verification email?",
        "backoffice.users.passwordreset.title": "Reset Password",
        "backoffice.users.passwordreset.message": "Are you sure you want to reset ${username}'s password? The user will receive an email with a link to reset their password.",
        "backoffice.users.passwordreset.titleconfirmation": "Email sent",
        "backoffice.users.passwordreset.messageconfirmation": "The password reset email was sent successfully.",
        "backoffice.users.passwordreset.noredirecturl.title": "No Redirect-URL configured",
        "backoffice.users.passwordreset.noredirecturl.message": "There is no Redirect-URL configured for your project. Please contact the support, so we can set one for you.",
        "backoffice.users.passwordreset.noredirecturl.contact": "Contact support",
        "backoffice.users.passwordreset.noredirecturl.moreinfo": "Further information:"
    };
}
exports.backofficeUsers_en_us = backofficeUsers_en_us;
